export default __webpack_public_path__ + "static/media/oak.side.texture.1dd03982.webp";